import { Link } from "react-router-dom";
import "../../assets/css/wes-terms-and-conditions.css";

export const Termsandconditions = () => {
  return (
    <main className="wes-terms-and-conditions-content">
      <section className="wes-terms-and-conditions-style-1">
        <div className="wes-terms-and-conditions-style-2">
          <nav aria-label="Breadcrumb" className="wes-terms-and-conditions-style-3">
            <Link to="/" className="wes-terms-and-conditions-style-4">
              Home
            </Link>
            <span aria-hidden="true">›</span>
            <span className="wes-terms-and-conditions-style-5">Terms and Conditions</span>
          </nav>
          <div className="wes-terms-and-conditions-style-6">
            <span className="wes-terms-and-conditions-style-7">Legal</span>
            <h1 className="wes-terms-and-conditions-style-8">Terms and Conditions</h1>
            <p className="wes-terms-and-conditions-style-9">
              WES Australasia is an independent, Australian owned, business to business distributor of electronic and
              electrical products and accessories to the Audio / Visual, Electronic and Electrical industries.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div className="wes-terms-and-conditions-style-10">
          <article className="wes-legal-body">
            <section id="tc-the-products" className="wes-legal-sec">
              <h2 className="tc-h">THE PRODUCTS</h2>
              <p>
                Goods supplied are sourced from numerous suppliers locally and overseas. It is our policy to purchase
                from reputable suppliers to ensure that the products are of the highest quality.
              </p>
            </section>
            <section id="tc-ownership-of-goods" className="wes-legal-sec">
              <h2 className="tc-h">OWNERSHIP OF GOODS</h2>
              <p>
                Goods and services supplied by WES remain the property of WES, in accordance with the retention of title
                clause, until the goods supplied are paid for in full by the customer.
              </p>
            </section>
            <section id="tc-liability" className="wes-legal-sec">
              <h2 className="tc-h">LIABILITY</h2>
              <p>
                The use of the products purchased is beyond our control or supervision. To the extent permitted by law,
                we cannot accept any liability for losses or consequential damage to any goods or equipment.
              </p>
              <p>
                In the event of a product being faulty within the warranty period, we will make a claim to our supplier
                on your behalf. Each supplier has their own policy on how they deal with returned goods, which may range
                from repair to replacement after inspection.
              </p>
            </section>
            <section id="tc-dangerous-goods" className="wes-legal-sec">
              <h2 className="tc-h">DANGEROUS GOODS</h2>
              <p>
                Orders with goods which are restricted, such as some batteries, aerosols or isopropanol products, must
                be sent by road service.
              </p>
            </section>
            <section id="tc-back-orders" className="wes-legal-sec">
              <h2 className="tc-h">BACK ORDERS</h2>
              <p>
                Goods not in stock will be automatically back ordered and shipped when available with your next order,
                unless otherwise requested.
              </p>
            </section>
            <section id="tc-goods-returned" className="wes-legal-sec">
              <h2 className="tc-h">GOODS RETURNED</h2>
              <p>
                It is essential that you obtain a Return Authorisation number (RA) before returning any goods. All goods
                to be returned must be sent freight prepaid, and the RA number must be clearly written on the parcel.
                Parcels returned without an RA will not be accepted or will be returned.
              </p>
              <p>
                Faulty goods will be returned to our supplier for their determination. Faulty goods will be repaired,
                replaced or credited in accordance with the Australian Consumer Law.
              </p>
              <p>
                Damaged goods and incorrect use: Goods will not be accepted as faulty, and will not be repaired,
                replaced or credited, where the damage or failure has been caused by:
              </p>
              <ul>
                <li>physical damage after delivery, including drops, impacts, crushing, water or heat damage;</li>
                <li>damage caused by the customer or a third party;</li>
                <li>
                  incorrect installation or use, or use not in line with the manufacturer's instructions or
                  specifications;
                </li>
                <li>spare parts or components damaged by a fault in the equipment or device they were fitted to.</li>
              </ul>
              <p>
                Goods returned for assessment that are found to fall under these conditions will be returned to the
                customer at the customer's cost. An assessment or handling fee may apply.
              </p>
              <p>Goods purchased incorrectly or no longer required cannot be returned.</p>
            </section>
            <section id="tc-errors-omissions" className="wes-legal-sec">
              <h2 className="tc-h">ERRORS / OMISSIONS</h2>
              <p>
                Due to the size of this catalogue and the thousands of products it contains, it is possible that
                mistakes exist. All care has been taken to eliminate errors, however no liability can be accepted for
                errors.
              </p>
              <p>
                We recommend that this catalogue be used as a guide only, and that you do your own research to ensure
                the products are suitable for your application prior to purchase. Please advise us if you find any
                discrepancies.
              </p>
            </section>
            <section id="tc-delivery" className="wes-legal-sec">
              <h2 className="tc-h">DELIVERY</h2>
              <p>
                Delivery and handling charges apply to all orders. We have a number of shipping options to cover most
                requirements and can ship locally, Australia wide and overseas.
              </p>
              <p>
                Risk in the goods passes to you when the goods leave our premises, whether collected by our nominated
                carrier, your own courier, or picked up by you. This applies even though ownership of the goods remains
                with WES until they are paid for in full (see Ownership of Goods).
              </p>
            </section>
            <section id="tc-checking-your-order" className="wes-legal-sec">
              <h2 className="tc-h">CHECKING YOUR ORDER</h2>
              <p>
                Please check your goods against the picking slip or invoice as soon as they arrive. If the carton is
                visibly damaged, please note the damage on the carrier's delivery docket before signing.
              </p>
            </section>
            <section id="tc-short-delivery-incorrect-goods" className="wes-legal-sec">
              <h2 className="tc-h">SHORT DELIVERY / INCORRECT GOODS</h2>
              <p>
                Any shortage or incorrect item must be reported to WES in writing (email is fine) within 7 days of
                delivery. Please include your invoice number and a list of the missing or incorrect items.
              </p>
              <p>
                Claims received after 7 days may not be accepted, and the order will be treated as received in full and
                correct.
              </p>
            </section>
            <section id="tc-goods-damaged-in-transit" className="wes-legal-sec">
              <h2 className="tc-h">GOODS DAMAGED IN TRANSIT</h2>
              <p>
                Goods damaged in transit must be reported to WES in writing within 7 days of delivery. Please include
                your invoice number, photos of the damaged goods, and photos of the carton, packaging and shipping
                label.
              </p>
              <p>
                Please keep all goods and packaging until the claim is finalised, as we may need to inspect them. Do not
                use or install damaged goods.
              </p>
              <p>Claims received after 7 days may not be accepted.</p>
            </section>
            <section id="tc-delivery-address" className="wes-legal-sec">
              <h2 className="tc-h">DELIVERY ADDRESS</h2>
              <p>
                You are responsible for ensuring the delivery address supplied at the time of order is correct and
                complete. Please check your address carefully before submitting your order, as changes cannot be
                guaranteed once goods have been dispatched.
              </p>
              <p>
                Where goods are returned to WES because of an incorrect or incomplete address, or because a delivery is
                unclaimed or refused, any return freight, redelivery and handling costs will be charged to you for
                payment before the goods are redelivered.
              </p>
            </section>
            <section id="tc-lost-or-missing-parcels" className="wes-legal-sec">
              <h2 className="tc-h">LOST OR MISSING PARCELS</h2>
              <p>
                A tracking number is provided with every dispatched order. If your order has not arrived by the expected
                delivery date, please check the tracking details and contact the carrier directly to follow up delivery,
                as the carrier is best placed to locate your parcel.
              </p>
              <p>
                If the carrier is unable to locate your parcel, please contact WES in writing within 10 days of the
                expected delivery date. Please include your invoice number, tracking number and details of your contact
                with the carrier.
              </p>
              <p>Parcels marked as delivered by the carrier are considered delivered to the address you supplied.</p>
            </section>
            <section id="tc-transport-companies" className="wes-legal-sec">
              <h2 className="tc-h">TRANSPORT COMPANIES</h2>
              <p>
                Once goods leave our premises, they are in the care of the transport company, and WES has no control
                over their handling or delivery times. WES is not responsible for delays, loss or damage caused by the
                carrier, except where required by law.
              </p>
              <p>
                Where you arrange your own courier or pick-up, the goods are your responsibility from the time they are
                collected, and any claim must be made by you directly with your courier.
              </p>
            </section>
            <section id="tc-standard-mail-parcel-post" className="wes-legal-sec">
              <h2 className="tc-h">STANDARD MAIL PARCEL POST</h2>
              <p>
                Ideal for light parcels, e.g. up to 200 grams, actual weight or cubic. Parcels over 200 grams will be
                sent in the most economical way.
              </p>
              <p>
                Note: Deliveries to PO Boxes and Parcel Lockers result in additional charges and are not recommended. If
                a PO Box is the only address option, the goods will be shipped, however any additional costs incurred
                will be passed on.
              </p>
            </section>
            <section id="tc-standard-deliveries-sydney-metro" className="wes-legal-sec">
              <h2 className="tc-h">STANDARD DELIVERIES SYDNEY METRO</h2>
              <p>
                Sydney Metropolitan Road Service. Goods are usually shipped out the same day in the afternoon and
                delivered the next working day. This is our most economical service.
              </p>
            </section>
            <section id="tc-standard-australia-wide-delivery" className="wes-legal-sec">
              <h2 className="tc-h">STANDARD AUSTRALIA WIDE DELIVERY</h2>
              <p>
                Australia Wide Road Service. Delivery times will vary according to your location. This is the most
                economical way to ship goods, including heavy and bulky goods, lithium batteries, products with lithium
                batteries fitted, aerosols and other items classified as dangerous goods.
              </p>
            </section>
            <section id="tc-express-delivery-service" className="wes-legal-sec">
              <h2 className="tc-h">EXPRESS DELIVERY SERVICE</h2>
              <p>
                This service is considerably more expensive than the Standard Road Service. Delivery to capital cities
                is usually within 1–2 working days, and remote areas 2–4 working days. In general, the Express Service
                is faster than the Standard Road Service.
              </p>
              <p>Order before 2pm (Sydney time) for same day despatch.</p>
              <p>
                We will select the transport company which we believe will be best for your area, however once the
                parcel leaves our premises we have no control over the transport company and are unable to claim for
                late deliveries.
              </p>
              <p>
                Note: This service is not available for orders containing dangerous goods, e.g. aerosols, batteries,
                etc.
              </p>
            </section>
            <section id="tc-international-orders" className="wes-legal-sec">
              <h2 className="tc-h">INTERNATIONAL ORDERS</h2>
              <p>
                International Mail and Express shipping is available for international orders. You are welcome to
                nominate your own transport, and we will have the goods packed and ready for pick up by your chosen
                courier from our premises.
              </p>
            </section>
            <section id="tc-drop-shipment" className="wes-legal-sec">
              <h2 className="tc-h">DROP SHIPMENT</h2>
              <p>
                Available for online orders only. We will send goods directly to your customer. No invoice will be
                enclosed in the parcel; only the picking slip is included. The invoice will be sent to you by email.
              </p>
            </section>
            <section id="tc-courier-pick-up" className="wes-legal-sec">
              <h2 className="tc-h">COURIER - PICK UP</h2>
              <p>
                You will need to organise your courier to pick up the goods from our premises. Please provide details of
                the transport company picking up the order in the comments section when submitting your order.
              </p>
            </section>
            <section id="tc-click-collect-pick-up" className="wes-legal-sec">
              <h2 className="tc-h">CLICK &amp; COLLECT - PICK UP</h2>
              <p>
                Click and Collect pick-up is available from our showroom trade counter. Please allow 2 hours from
                placing your order before picking up in store. You will be notified by SMS and/or email once the order
                is ready to be collected.
              </p>
              <p>
                Goods can be picked up from our premises from 8.30am to 5.00pm Monday to Friday, and from 9.00am to
                2.00pm on Saturday. To avoid delays, we recommend you place your order before attending so the goods are
                ready to pick up.
              </p>
              <p>
                If you are picking up on Saturday, please place your order on Friday, as the WES call centre is closed
                on Saturday. If you need to contact us on Saturday, please call us on{" "}
                <a href="tel:+61297989233">02 9798 9233</a>.
              </p>
            </section>
            <section id="tc-location-hours" className="wes-legal-sec">
              <div className="wes-g2 wes-terms-and-conditions-style-11">
                <div className="wes-terms-and-conditions-style-12">
                  <h2 className="tc-h">SYDNEY METRO WAREHOUSE IS LOCATED AT:</h2>
                  <p>84-90 PARRAMATTA RD, SUMMER HILL, NSW 2130</p>
                </div>
                <div className="wes-terms-and-conditions-style-12">
                  <h2 className="tc-h">SHOP FRONT OPEN HOURS:</h2>
                  <p>Monday to Friday 8.30am to 5.00pm.</p>
                  <p>Saturday 9.00am to 2.00pm. Closed Sundays and Public Holidays.</p>
                </div>
              </div>
            </section>
            <section id="tc-your-rights-under-australian-consumer-law" className="wes-legal-sec">
              <h2 className="tc-h">YOUR RIGHTS UNDER AUSTRALIAN CONSUMER LAW</h2>
              <p>
                Nothing in these Terms and Conditions excludes, restricts or changes any rights you may have under the
                Australian Consumer Law or any other law that cannot be excluded. Our goods come with guarantees that
                cannot be excluded under the Australian Consumer Law where it applies.
              </p>
            </section>
          </article>
        </div>
      </section>
    </main>
  );
};
